import React from 'react';

const ResizeControls = ({ onReset, onZoomIn, onZoomOut }) => (
    <div style={{
        position: 'absolute',
        bottom: '16px',
        left: '16px',
        display: 'flex',
        gap: '8px',
        background: 'white',
        padding: '8px',
        borderRadius: '12px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(0, 0, 0, 0.1)'
    }}>
        <button
            onClick={onZoomOut}
            style={{
                width: '36px',
                height: '36px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'white',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                color: '#666',
                fontSize: '18px',
                ':hover': {
                    background: '#f5f5f5',
                    borderColor: '#d0d0d0'
                }
            }}
        >
            −
        </button>
        <button
            onClick={onReset}
            style={{
                padding: '0 16px',
                height: '36px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'white',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                color: '#666',
                fontSize: '14px',
                fontWeight: '500',
                ':hover': {
                    background: '#f5f5f5',
                    borderColor: '#d0d0d0'
                }
            }}
        >
            Reset
        </button>
        <button
            onClick={onZoomIn}
            style={{
                width: '36px',
                height: '36px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'white',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                color: '#666',
                fontSize: '18px',
                ':hover': {
                    background: '#f5f5f5',
                    borderColor: '#d0d0d0'
                }
            }}
        >
            +
        </button>
    </div>
);

export default ResizeControls; 